// src/services/IntakeQuestionService.ts

import { IntakeQuestion } from "../models/IntakeQuestion";
import { Answer } from "../models/Answer";
import { Event } from "../models/Event";
import api from "./api";
import { clean } from "../utils/utils";

const PATH = "/api/v1/intakeQuestions";

export const IntakeQuestionService = {
  async createIntakeQuestion(
    intakeQuestionData: Omit<
      IntakeQuestion,
      "_id" | "createdAt" | "updatedAt" | "createdById" | "updatedById"
    >, // Exclude fields that are auto-generated
  ): Promise<string> {
    const res = await api.post(PATH, intakeQuestionData);
    return res.data.data._id; // Return the ID of the created IntakeQuestion
  },

  async getIntakeQuestion(
    intakeQuestionId: string,
  ): Promise<IntakeQuestion | null> {
    try {
      const res = await api.get<IntakeQuestion>(`${PATH}/${intakeQuestionId}`);
      return res.data;
    } catch (err: any) {
      if (err.response?.status === 404) return null;
      throw err;
    }
  },

  async getAllIntakeQuestions(matterId: string): Promise<IntakeQuestion[]> {
    const res = await api.get<IntakeQuestion[]>(PATH, {
      params: { matterId },
    });
    return res.data;
  },

  async createAnswer(
    intakeQuestionId: string,
    answerData: Omit<Answer, "_id" | "createdAt" | "updatedAt">,
  ): Promise<string> {
    const res = await api.post(`${PATH}/${intakeQuestionId}/answers`, {
      ...clean(answerData),
    });
    return res.data.data._id;
  },

  async updateIntakeQuestion(
    intakeQuestionId: string,
    updatedData: Partial<Omit<IntakeQuestion, "_id" | "createdAt">>,
  ): Promise<void> {
    await api.put(`${PATH}/${intakeQuestionId}`, updatedData);
  },

  async deleteIntakeQuestion(intakeQuestionId: string): Promise<void> {
    await api.delete(`${PATH}/${intakeQuestionId}`);
  },
};
